import React from 'react';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { ReadOnlyDocumentContent } from '../../RichTextEditor';

import { useCommentsModalState, useCommentsModalActions } from './CommentsModalContext';
import CommentsModalLoader from './CommentsModalLoader';
import Button from '../../Shared/UI/Button/components/Button';

import styles from './CommentsModal.module.scss';

const CommentsModal = ({ parentId, parentType, modalOpen, handleCloseModal, handleOpenCommentModal, handleOpenCommentFormModal }) => {
  const state = useCommentsModalState();
  const { setCommentDataLoaded } = useCommentsModalActions();

  if (!modalOpen) {
    return null;
  }

  const comments = () => {
    return (state?.commentsModal?.commentData || []).map(comment => {
      const goToAuthorProfile = () => {
        window.location.assign(comment.author.path);
      }

      const handleViewReplies = () => {
        setCommentDataLoaded(false);
        handleOpenCommentModal({commentParentId: comment.id, commentParentType: 'Comment'});
      };

      return (
        <React.Fragment key={comment.id}>
          <hr id={styles.spacer}/>
          <div className={styles.authorIntro}>
            <img className={styles.authorPicture} src={comment.author.profilePicturePath} onClick={goToAuthorProfile}></img>
            <p className={styles.authorName}  onClick={goToAuthorProfile}>{comment.author.name}</p>
            <p className={styles.authorTagline}  onClick={goToAuthorProfile}>Biotech Enthusiast</p>
            <p className={styles.postDate}>{`Posted On ${new Date(Date.parse(comment.createdAt)).toLocaleDateString()}`}</p>
          </div>
          <div className={styles.commentTextContainer}>
            <ReadOnlyDocumentContent documentComponents={comment.latestVersion?.documentComponents} />
          </div>
          <div className={styles.repliesContainer}>
            <p className={styles.repliesCount} onClick={comment.replies.length ? () => handleViewReplies() : () => {}}>{`${comment.replies.length} ${comment.replies.length == 1 ? 'Reply' : 'Replies'}`}</p>
            |
            <p className={styles.repliesCount} onClick={() => handleOpenCommentFormModal({commentParentId: comment.id, commentParentType: 'Comment'})}>Make A Reply</p>
          </div>
        </React.Fragment>
      );
    });
  };

  return (
    <>
      <CommentsModalLoader parentId={parentId} parentType={parentType} />
      <StandardModal
        isOpen={modalOpen}
        onRequestClose={handleCloseModal}
      >
        <div id={styles.createPostsContainer}>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
        </div>
        {comments()}
      </StandardModal>
    </>
  );
};

export default CommentsModal;
